import { ChangeDetectionStrategy, Component, EventEmitter, Output, input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IButtonCustomClass } from '@data/schema';

@Component({
    selector: 'app-spinner-button',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './spinner-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerButtonComponent {
    buttonText = input.required<string>();
    icon = input<string>();
    prependIcon = input<string>();
    isProcessing = input<boolean>(false);
    isDisabled = input<boolean>(false);
    type = input<'button' | 'submit'>('submit');
    stopPropagation = input<boolean>(false);
    customClasses = input<IButtonCustomClass>({
        button: 'btn btn-primary fw-medium w-100',
        spinner: 'spinner-border spinner-border-sm me-2',
    });

    @Output() onButtonClick = new EventEmitter<void>();

    click($event: Event) {
        if (this.stopPropagation()) $event.stopPropagation();
        this.onButtonClick.emit();
    }
}
